import styled, { css } from 'styled-components';

interface StyledGridProps {
  $container?: boolean;
  $item?: boolean;
  $xs?: number;
  $marginTop?: number;
  $marginBottom?: number;
  $justifyContent?: string;
}

export const StyledGrid = styled.div<StyledGridProps>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;

  ${({ $container }) =>
    $container &&
    css`
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    `}

  ${({ $item, $xs }) =>
    $item &&
    css`
      flex-basis: ${$xs ? `${($xs / 12) * 100}%` : 'auto'};
      flex-grow: 0;
      max-width: ${$xs ? `${($xs / 12) * 100}%` : '100%'};
    `}

  ${({ $marginTop }) =>
    $marginTop !== undefined &&
    css`
      margin-top: ${$marginTop * 8}px;
    `}

  ${({ $marginBottom }) =>
    $marginBottom !== undefined &&
    css`
      margin-bottom: ${$marginBottom * 8}px;
    `}

  ${({ $justifyContent }) =>
    $justifyContent &&
    css`
      justify-content: ${$justifyContent === 'end' ? 'flex-end' : $justifyContent};
    `}
`;

// Read mode's SectionContainer pads 10px and the edit form does not, so the panel jumped on
// Edit. Matched here rather than on the form, which would restyle every entity section.
export const ScoringPanelWrapper = styled.div`
  /* Top only: repeating it at the bottom over-spaces the Save row. */
  padding: 10px 0 0;
  width: 100%;
`;
